exports.components = {
  "component---src-templates-article-article-tsx": () => import("./../../../src/templates/Article/Article.tsx" /* webpackChunkName: "component---src-templates-article-article-tsx" */),
  "component---src-templates-page-page-tsx": () => import("./../../../src/templates/Page/Page.tsx" /* webpackChunkName: "component---src-templates-page-page-tsx" */),
  "component---src-templates-search-search-results-tsx": () => import("./../../../src/templates/Search/SearchResults.tsx" /* webpackChunkName: "component---src-templates-search-search-results-tsx" */)
}

